<template>
    <transition name="slide" type="animation">
    <div class="card batch-box" v-if="files.length>0">
        <div class="card-body batch-options">
            <div class="num-of-actions_wrapper">
                <div class="num-of-actions" ><strong>{{ files.length }}</strong></div>
            </div>
            <div class="batch-actions-title-section">
                <div class="title">Photos sélectionnées</div>
                <div class="pulses_dots">
                    <div class="dot" v-for="file in files"></div>
                </div>
            </div>
            <div class="batch-actions-item" @click="removeItems">
                    <span class="fa fa-trash action-icon">
                    </span>
                <span class="action-name">Supprimer</span>
            </div>
            <div class="batch-actions-delete-item" @click="closeBatchBox"><span class="fa fa-close" ></span></div>
        </div>
    </div>
    </transition>
</template>

<script>
export default {
    name: "BatchActions",
    props: {
        files: {
            type: Array,
            default: ""
        },
    },
    methods: {
        removeItems() {
            this.$emit('removeItems', this.files);
        },
        closeBatchBox() {
            this.$emit('closeBatchBox');
        },
    },
}
</script>

<style scoped>
.num-of-actions{
    font-size: 30px;
}
.batch-actions-delete-item span{
    font-size: 30px;
}
.pulses_dots .dot {
    background: rgb(0 161 224 / 36%);
    width: 10px;
    height: 10px;
    border-radius: 50px;
}

.batch-options .batch-actions-delete-item {
    display: flex;
    width: 63px;
    cursor: pointer;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    border-left: 2px solid;
    border-left-color: #efefef;
}

.batch-actions-item .action-icon {
    color: red;
}

.batch-actions-item .action-name {
    font-size: 13px;
    position: relative;
    bottom: -4px;
}

.batch-actions-item .action-icon {
    font-size: 21px;
    position: relative;
}

.batch-actions-item {
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-right: 20px;
    cursor: pointer;
    margin-top: 10px;
}

.batch-options .num-of-actions_wrapper {
    width: 63px;
    color: #fff;
    background-color: #00a1e0;
    border-radius: 5px 0px 0px 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    cursor: default;
}

.batch-options .batch-actions-title-section {
    display: flex;
    justify-content: center;
    flex-direction: column;
    flex: 1;
    cursor: default;
}

.batch-options .batch-actions-title-section .title {
    color: #000;
    font-size: 20px;
    padding-left: 20px;
    font-weight: 100;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 300px;
}

.batch-actions-title-section .pulses_dots {
    color: #333;
    padding-left: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 20px;
}

.batch-box {
    position: fixed;
    bottom: 25px;
    margin-top: -100px;
    left: 50%;
    margin-left: -140px;
    z-index: 9999999;

}

.batch-options {
    transition: opacity 150ms, transform 150ms;
    position: absolute;
    width: 450px;
    height: 63px;
    z-index: 1000001;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: #535353;
    pointer-events: auto;
    flex-direction: row;
    display: flex;
    bottom: 35px;
    -webkit-user-select: none;
    user-select: none;
    padding: 0;
}
.slide-enter {
    opacity: 0;
}

.slide-enter-active {
    animation: slide-in 0.5s ease-in forwards;
    transition: opacity 0.5s;
}

.slide-leave-active {
    animation: slide-out 0.5s ease-out forwards;
    opacity: 0;
    transition: opacity 0.5s;
}

@keyframes slide-in {
    from {
        transform: translateY(20px);
    }
    to {
        transform: translateY(0);
    }
}
@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(20px);
    }
}
</style>
